import { Flex, Stack, Text } from '@chakra-ui/react'

import theme from 'theme'

import type { MatchDay } from 'types'

type Props = {
  days: MatchDay[]
  activeDay?: number
}

const ProgressDays = ({ days, activeDay }: Props) => {
  return (
    <Stack
      direction="row"
      maxW="130px"
      align="center"
      justify="center"
      backgroundColor={theme.colors.gray['200']}
      borderRadius="full"
      spacing="4px"
      userSelect="none"
      padding="2px 8px"
    >
      <Text textStyle="captionBold2" color={theme.baseColors.text.disabled}>
        Day
      </Text>
      {days.map(day => {
        const dayNum = day.dayNum ?? 1
        return (
          <Flex
            {...theme.baseComponents.matchCards.text.dayNumber}
            key={`day${dayNum}`}
            borderRadius="full"
            color={dayNum === activeDay ? theme.colors.white : theme.baseColors.text.disabled}
            backgroundColor={dayNum === activeDay ? theme.baseColors.secondary.main : theme.colors.white}
            w="14px"
            h="14px"
            minW="14px"
            align="center"
            justify="center"
          >
            {dayNum}
          </Flex>
        )
      })}
    </Stack>
  )
}

export default ProgressDays
